import { render, staticRenderFns } from "./guarantorReviewForm.vue?vue&type=template&id=51c67c77"
import script from "./guarantorReviewForm.vue?vue&type=script&lang=js"
export * from "./guarantorReviewForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports